import React from "react"
import partners from "../../images/partners.svg"

export default function PartnersLogos() {
	return (
		<div className="partners-container">
			<div className="partners-title">Powering leading tech brands</div>
			<div className="partners is-flex">
				<img className="is-flex-grow-1" src={partners} />
			</div>
		</div>
	)
}
